import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "ncgr-card ncgr-card--rounded-to-normal" }
const _hoisted_2 = { class: "ncgr-container ncgr-pad-t-24 ncgr-pad-b-24" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.payment.method === 'creditCard')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.useRegisteredCreditCard)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" 前回ご利用のカード ")
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" クレジットカード・デビットカード：" + _toDisplayString(_ctx.payment.cardNumber), 1)
                ], 64))
          ]))
        : _createCommentVNode("", true),
      (_ctx.payment.method === 'deferred')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, " コンビニ・銀行 "))
        : _createCommentVNode("", true),
      (_ctx.payment.method === 'sampleOrder')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, " サンプル発注 "))
        : _createCommentVNode("", true)
    ])
  ]))
}